var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{staticClass:"mb-0 announcement-banner text-center",attrs:{"text":"","dense":"","color":_vm.color}},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"grow"},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)],1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }